import { render, staticRenderFns } from "./PersonalPorEstatus.vue?vue&type=template&id=50dce012&scoped=true"
import script from "./PersonalPorEstatus.vue?vue&type=script&lang=js"
export * from "./PersonalPorEstatus.vue?vue&type=script&lang=js"
import style0 from "./PersonalPorEstatus.vue?vue&type=style&index=0&id=50dce012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dce012",
  null
  
)

export default component.exports